<div class="container-fluid admin-container mb-5 " *ngIf="!isLoading">
  <div class="row">
    <div class="col-md-12">
      <div class="page-header">
        <div>
          <p class="page-title"> {{lblCreateText}} </p>
        </div>
      </div>
    </div>
  </div>
  <form [formGroup]="idnInfoForm" (ngSubmit)="onSubmit()" id="idnInfoForm" class="row">
    <div class="col-md-3">
      <h3 class="mb-3"><strong>{{resourceKeyValue.idnDetails}}</strong></h3>

      <div class="form-group">
        <label class="control-label-required" for="name">
          <span *ngIf="createMode" class="required">* </span>
          {{resourceKeyValue.idnName}}
        </label>
        <input *ngIf="isEdit" type="text" class="form-control" id="idnName"
          placeholder={{resourceKeyValue.idnNamePlaceholder}} formControlName="idnName">
        <input *ngIf="createMode" type="text" placeholder={{resourceKeyValue.selectIdnName}} matInput
          class="custom-select name-field"
          [class.is-invalid]="idnInfoForm.controls.name.invalid && idnInfoForm.controls.name.dirty"
          formControlName="name" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option [value]="resourceKeyValue.selectIdnName">
            {{resourceKeyValue.selectIdnName}}
          </mat-option>
          <mat-option *ngFor="let tenant of filteredOptions | async" [value]="tenant.name">
            {{tenant.name}}
          </mat-option>
        </mat-autocomplete>
        <div class="invalid-feedback" *ngIf="idnInfoForm.controls.name.invalid && idnInfoForm.controls.name.dirty"
          id="name-validation">
          <small *ngIf="idnInfoForm.controls.name.errors.required">{{resourceKeyValue.validationNameRequired}}</small>
          <small
            *ngIf="idnInfoForm.controls.name.errors.errorName">{{resourceKeyValue.validationIDNNameAlreadyExist}}</small>
          <small
            *ngIf="idnInfoForm.controls.name.errors.maxlength">{{resourceKeyValue.validationLengthMustbe200Characters}}</small>
          <small
            *ngIf="idnInfoForm.controls.name.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
          <small *ngIf="idnInfoForm.controls.name.errors?.errorIDN">{{resourceKeyValue.validationIDNNotExists}}</small>
        </div>
      </div>
      <div class="form-group">
        <label for="idnCode">{{resourceKeyValue.idnCode}}</label>
        <input type="text" class="form-control" id="idnCode" placeholder={{resourceKeyValue.idnCodePlaceholder}}
          formControlName="idnCode">
      </div>
      <div class="form-group">
        <label for="accountNumber">{{resourceKeyValue.idnAccountNumber}}</label>
        <input type="text" class="form-control" id="accountNumber"
          placeholder={{resourceKeyValue.accountNumberPlaceholder}} formControlName="accountNumber"
          [class.is-invalid]="idnInfoForm.controls.accountNumber.invalid && idnInfoForm.controls.accountNumber.dirty">
        <div class="invalid-feedback"
          *ngIf="idnInfoForm.controls.accountNumber.invalid && idnInfoForm.controls.accountNumber.dirty"
          id="accountNumber-validation">
          <small
            *ngIf="idnInfoForm.controls.accountNumber.errors.maxlength">{{resourceKeyValue.validationLengthMustbe255Characters}}</small>
          <small
            *ngIf="idnInfoForm.controls.accountNumber.errors?.containsWhiteSpace">{{resourceKeyValue.whiteSpaceNotAllowed}}</small>
        </div>
      </div>
    </div>
    <div class="col-md-3 offset-1">
      <h3 class="mb-3"><strong>{{resourceKeyValue.idnAddress}}</strong></h3>
      <div class="form-group">
        <label for="countryId">{{resourceKeyValue.idnCountry}}</label>
        <select class="custom-select select-field" id="countryId" formControlName="countryId"
          [(ngModel)]='selectedCountry' (change)="selectCountry($event.target.value)">
          <option [value]="0" disabled>{{resourceKeyValue.hintSelectCountry}}</option>
          <option *ngFor="let country of allCountries" [value]="country.id">{{country.name}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="address1">{{resourceKeyValue.idnAddressLine1}}</label>
        <input type="text" class="form-control" id="address1" placeholder={{resourceKeyValue.hintAddressLine1}}
          formControlName="address1"
          [class.is-invalid]="idnInfoForm.controls.address1.invalid && idnInfoForm.controls.address1.dirty">
        <div class="invalid-feedback"
          *ngIf="idnInfoForm.controls.address1.invalid && idnInfoForm.controls.address1.dirty" id="address1-validation">
          <small
            *ngIf="idnInfoForm.controls.address1.errors.maxlength">{{resourceKeyValue.validationLengthMustbe255Characters}}</small>
          <small
            *ngIf="idnInfoForm.controls.address1.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
        </div>
      </div>
      <div class="form-group">
        <label for="address2">{{resourceKeyValue.idnAddressLine2}}</label>
        <input type="text" class="form-control" id="address2" placeholder={{resourceKeyValue.hintAddressLine2}}
          formControlName="address2"
          [class.is-invalid]="idnInfoForm.controls.address2.invalid && idnInfoForm.controls.address2.dirty">
        <div class="invalid-feedback"
          *ngIf="idnInfoForm.controls.address2.invalid && idnInfoForm.controls.address2.dirty" id="address2-validation">
          <small
            *ngIf="idnInfoForm.controls.address2.errors.maxlength">{{resourceKeyValue.validationLengthMustbe255Characters}}</small>
          <small
            *ngIf="idnInfoForm.controls.address2.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
        </div>
      </div>
      <div class="form-row"></div>
      <div class="form-group">
        <label for="city">{{resourceKeyValue.idnCity}}</label>
        <input type="text" class="form-control" id="city" formControlName="city"
          placeholder={{resourceKeyValue.hintCity}}
          [class.is-invalid]="idnInfoForm.controls.city.invalid && idnInfoForm.controls.city.dirty">
        <div class="invalid-feedback" *ngIf="idnInfoForm.controls.city.invalid && idnInfoForm.controls.city.dirty"
          id="city-validation">
          <small
            *ngIf="idnInfoForm.controls.city.errors.maxlength">{{resourceKeyValue.validationLengthMustbe255Characters}}</small>
          <small
            *ngIf="idnInfoForm.controls.city.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
        </div>
      </div>
      <div class="form-group">
        <label for="state">{{resourceKeyValue.idnState}}</label>
        <select class="custom-select" id="state" formControlName="state" [(ngModel)]='selectedStateValue'>
          <option [value]="0" disabled>{{resourceKeyValue.hintSelectState}}</option>
          <option *ngFor="let state of allStates" [value]="state.code">{{state.name}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="zipCode">{{resourceKeyValue.idnPostalCode}}</label>
        <input type="text" class="form-control" id="zipCode" formControlName="zipCode"
          placeholder={{resourceKeyValue.hintPostalCode}}
          [class.is-invalid]="idnInfoForm.controls.zipCode.invalid && idnInfoForm.controls.zipCode.dirty">
        <div class="invalid-feedback" *ngIf="idnInfoForm.controls.zipCode.invalid && idnInfoForm.controls.zipCode.dirty"
          id="zipCode-validation">
          <small
            *ngIf="idnInfoForm.controls.zipCode.errors.maxlength">{{resourceKeyValue.validationLengthMustbe10Characters}}</small>
          <small *ngIf="idnInfoForm.controls.zipCode.errors.pattern">{{resourceKeyValue.validationPostalCode}}</small>
        </div>
      </div>
      <div class="form-group invisible-collapsed" [hidden]="true">
        <label for="id">ID</label>
        <input type="text" disabled=true class="form-control" id="id" placeholder="ID" formControlName="id" value="0">
      </div>
    </div>
  </form>
  <div class="form-button-fixed">
    <button id="cancelCreateIdnBtn" class="btn btn-secondary" [routerLink]="['/idns']">
      {{btnCancelText}}
    </button>
    <button id="btnSelectIdn" form="idnInfoForm" type="submit" class="btn btn-primary ml-3"
      [disabled]="isLoading || !idnInfoForm.valid || (idnInfoForm.valid && idnInfoForm.pristine)">
      {{btnCreateText}}
    </button>
  </div>
</div>
<app-loader [isLoading]=isLoading></app-loader>